import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  showDialog: false,
  isLoading: false,
  itemTypesList: [],
  itemStatusList: [],
  itemCategoriesList: [],
};

//STORE SLICE
export const itemsAddSlice = createSlice({
  name: "itemsAddSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showAddItemsDialog(state) {
      return {
        ...state,
        showDialog: true,
      };
    },
    closeAddItemsDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    }, 
    setItemTypesList(state, action) {
      return {
        ...state,
        itemTypesList: action.payload
      }
    },
    setItemStatusList(state, action) {
      return {
        ...state,
        itemStatusList: action.payload
      }
    },
    setItemCategoriesList(state, action) {
      return {
        ...state,
        itemCategoriesList: action.payload
      }
    }, 
  },
});

//ACTIONS
export const {
  showAddItemsDialog,
  closeAddItemsDialog,
  showLoading,
  hideLoading,
  setItemTypesList,
  setItemStatusList,
  setItemCategoriesList,
} = itemsAddSlice.actions;

export default itemsAddSlice.reducer;
